/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

/* eslint-disable import/prefer-default-export */
import {
    // unitBase,
    rowSpacing,
    fontSizeDesktop,
    // fontSize,
    enterpriseCSS,
    paletteHD,
} from './variables';

export const DesktopTrackOrderStyle = (typography, palette) => {
    const newPalette = !palette || !palette.cta1 ? paletteHD : palette;
    return {
        DesktopTrackOrderStyle: {
            maxWidth: newPalette.myAccount.container.maxWidth.upLarge,
            margin: 'auto',
            display: 'flex',
            marginBottom: rowSpacing * 5, // 60px

            '& .deliveryHouseContainer': {
                backgroundColor: newPalette.myAccount.blockBorderRight,
                color: newPalette.black,
                width: rowSpacing * 16, // 192px
                minHeight: '313px',
                fontFamily: 'Halvetic',
                marginTop: rowSpacing * 2,
                display: 'inline-block',
                float: 'left',
                textAlign: 'center',
                '& span': {
                    display: 'block',
                    lineHeight: '19px',
                    letterSpacing: '0.35px',
                },
                '& .truckIcon': {
                    width: '36px',
                    height: '26px',
                    marginTop: rowSpacing * 3,
                },
                '& .deliveryText': {
                    fontSize: '16px',
                    paddingTop: '13px',
                    fontWeight: 'Bold',
                    textTransform: 'uppercase',
                },
                '& .line': {
                    width: rowSpacing * 12, // 144px
                    borderBottom: '1px solid',
                    display: 'block',
                    margin: '0 auto',
                    marginTop: rowSpacing * 2,
                },
                '& .hosueContainer': {
                    paddingTop: rowSpacing * 2,
                    fontSize: '14px',
                    '& div': {
                        display: 'inline-block',
                        verticalAlign: 'middle',
                    },
                    '& .houseIcon': {
                        width: '28px',
                        height: '24px',
                        display: 'block',
                    },
                },
                '& .bulidingContainer': {
                    paddingTop: rowSpacing * 4, // 48px
                    fontSize: '14px',
                    '& div': {
                        display: 'inline-block',
                        verticalAlign: 'middle',
                    },
                    '& .bulidingIcon': {
                        width: '23px',
                        height: '26px',
                        display: 'block',
                    },
                },
                '& .leftIconMargin': {
                    marginLeft: '14px',
                },
            },

            '& .OR-dividerWrapper': {
                display: 'flex',
                minHeight: '344px',
                float: 'left',
                marginTop: '24px',
                verticalAlign: 'middle',
                alignItems: 'center',
                margin: `0 ${rowSpacing * 4}px`, // 0 48px
                '& .OR-divider': {
                    color: newPalette.white,
                    display: 'inline-grid',
                    backgroundColor: newPalette.myAccount.contentGridBorder,
                    borderRadius: '50%',
                    width: '50px',
                    height: '50px',
                    fontSize: '16px',
                    fontWeight: 'bold',
                    textTransform: 'uppercase',
                    textAlign: 'center',
                    alignItems: 'center',
                },
            },

            '& .signInContainer, & .trackOrderContainer': {
                backgroundColor: newPalette.white,
                width: rowSpacing * 38, // 432px
                minHeight: rowSpacing * 30, // 360px
                fontFamily: 'Halvetic',
                marginTop: rowSpacing * 2, // 24px
                display: 'block',
                textAlign: 'center',
                margin: '0 auto',
                float: 'left',
                padding: '28px',

                '& .header': {
                    fontSize: '22px',
                    marginTop: rowSpacing * 2,
                    fontWeight: 'bold',
                    textTransform: 'capitalize',
                },
                '& .sub-header': {
                    fontSize: '14px',
                    color: newPalette.common?.darkGray,
                    whiteSpace: 'nowrap',
                    '@media screen and (max-width: 600px)': {
                        whiteSpace: 'normal',
                    },
                },
                '& .sub-header-ca': {
                    fontSize: '14px',
                    color: newPalette.common?.darkGray,
                },
                '& .track-icon': {
                    height: '43px',
                },
            },

            '& .signInContainer': {
                '& .signInBtnWrapper': {
                    marginTop: rowSpacing * 4,
                    '& .signInBtn, & .signInWithoutPasswordBtn': {
                        fontWeight: 700,
                        backgroundColor: newPalette.colorPrimary,
                        border: `1px solid ${newPalette.colorPrimary}`,
                        width: '100%',
                        float: 'none',
                    },
                    '& .signInWithoutPasswordBtn': {
                        backgroundColor: enterpriseCSS.palette.gray1,
                        border: `1px solid ${enterpriseCSS.palette.gray1}`,
                        marginTop: rowSpacing * 2,
                    },
                },
                '& .signUpDivider': {
                    margin: '0 auto',
                    marginTop: rowSpacing * 5,
                    '& span': {
                        fontSize: fontSizeDesktop.component,
                        display: 'inline-block',
                        color: newPalette.myAccount.contentGridBorder,
                        verticalAlign: 'top',
                        width: '120px',
                    },
                    '& hr': {
                        border: `1px solid ${newPalette.myAccount.blockBorderRight}`,
                        display: 'inline-block',
                        width: 'calc(50% - 60px)',
                    },
                    '& hr:nth-of-type(1n)': {
                        float: 'left',
                    },
                    '& hr:nth-of-type(2n)': {
                        float: 'right',
                    },
                },
                '& .socialBtn': {
                    margin: '0 auto',
                    marginTop: rowSpacing,
                    marginBottom: 0,
                    display: 'block',
                    height: rowSpacing * 3,

                    '&:after': {
                        content: '""',
                        float: 'none',
                        clear: 'both',
                    },

                    '& .loginSocialBtn': {
                        width: rowSpacing * 14,
                        height: rowSpacing * 3,
                        fontWeight: '330',
                        textTransform: 'none',
                        // fontSize: `${fontSizeDesktop.small}px !important`,
                        marginRight: 0,
                        display: 'inline-block',
                        padding: '0px',
                        '& span': {
                            textAlign: 'initial',
                        },
                    },
                    '& .facebookLogin': {
                        backgroundColor: '#4469B0',  // TO DO
                        border: '1px solid #4469B0',
                        color: newPalette.white,
                        float: 'left',
                        '&:hover': {
                            backgroundColor: '#4469B0', // TO DO
                        },
                    },
                    '& .googleLogin': {
                        backgroundColor: '#FFF',
                        border: '1px solid #FFF',
                        float: 'right',
                        color: '#000',
                        boxShadow: '0px 1.8px 7px -1px rgb(0,0,0,0.4)',
                        '&:hover': {
                            backgroundColor: newPalette.white,
                        },
                        '& img': {
                            marginRight: '18px',
                        },
                    },
                    '& .socialLoginImg': {
                        width: '13.6px',
                        height: '13.85px',
                        verticalAlign: 'sub',
                        margin: '0 9px',
                    },
                },
            },

            '& .trackOrderContainer': {
                width: rowSpacing * 30, // 360px

                '& form': {
                    marginTop: rowSpacing * 5, // 60px
                    '& .label-style': {
                        fontWeight: 'bold',
                        fontSize: '14px',
                        marginTop: '15px',
                        marginBottom: '5px',
                        color: newPalette.black,
                    },
                    '& .desktop-field': {
                        fontWeight: 'bold',
                        fontSize: '14px',
                        lineHeight: '20px',
                        '& input::placeholder': {
                            fontSize: '14px',
                        },
                    },
                },

                '& .submitBtn': {
                    fontWeight: 700,
                    backgroundColor: newPalette.secondary?.main,
                    border: `1px solid ${newPalette.secondary?.main}`,
                    width: '100%',
                    float: 'none',
                    '&:hover': {
                        backgroundColor: newPalette.secondary?.main,
                    },
                    color: newPalette.black,
                },

                '& .captchaContainer': {
                    width: '100%',
                    display: 'block',
                    position: 'relative',
                    minHeight: '74px',
                    marginTop: rowSpacing * 2,
                    '& #g-recaptcha > div': {
                        width: '100% !important',
                    },
                },
                '@media screen and (max-width: 375px)': {
                    padding: '10px',
                },
                '& .sub-header': {
                    '@media screen and (min-width: 768px)': {
                        position: 'absolute',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                    },
                },
            },
        },
    };
};
